import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuManagementComponent } from './menu/menu-management/menu-management.component';
import { LanguagesComponent } from './pages/languages/languages.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { RoleComponent } from './pages/role/role.component';
import { PopularDestinationsComponent } from './pages/popular-destinations/popular-destinations.component';
import { PopularDestinationsCategoryComponent } from './pages/popular-destinations-category/popular-destinations-category.component';
import { QuotationLeaderComponent } from './pages/quotation-leader/quotation-leader.component';
import { LeadershipComponent } from './pages/leadership/leadership.component';
import { NewsComponent } from './pages/news/news.component';
import { PolicyLawsComponent } from './pages/policy-laws/policy-laws.component';
import { DocumentComponent } from './pages/document/document.component';
import { DocumentTypeComponent } from './pages/document-type/document-type.component';
import { NewsCategoryComponent } from './pages/news-category/news-category.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { PermissionGuard } from './guards/permission.guard';
import { ProfileComponent } from './pages/profile/profile.component';
import { EServiceCategoryComponent } from './pages/e-service-category/e-service-category.component';
import { EServiceComponent } from './pages/e-service/e-service.component';
import { LinksComponent } from './pages/links/links.component';
import { LocationComponent } from './pages/location/location.component';
import { UserComponent } from './pages/user/user.component';
import { ContactMessageComponent } from './pages/contact-message/contact-message.component';
import { StatisticsV2Component } from './pages/statistics-v2/statistics-v2.component';
import { TourismMapComponent } from './pages/tourism-map/tourism-map.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'lang', component: LanguagesComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'role', component: RoleComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'user', component: UserComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'popular-destinations-category', component: PopularDestinationsCategoryComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'popular-destinations', component: PopularDestinationsComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'quotation-leader' , component: QuotationLeaderComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'leadership', component: LeadershipComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'links', component: LinksComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'policy-laws', component: PolicyLawsComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'document', component: DocumentComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'document-type', component: DocumentTypeComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'news-category', component: NewsCategoryComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'location', component: LocationComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'e-service-category', component: EServiceCategoryComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'e-service', component: EServiceComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'news' , component: NewsComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'contact-message', component: ContactMessageComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'statistics-v2', component: StatisticsV2Component, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'tourism-map', component: TourismMapComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: 'menu', component: MenuManagementComponent, canActivate: [AuthGuard, PermissionGuard] },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
